module.exports = ".container {\n  height: 100%; }\n\n.container > svg, svg.main {\n  width: 100%;\n  height: 100%; }\n"